module.exports = __webpack_public_path__ + "static/media/oncopassport-logo.03c05610.png";